<template>
  <div class="activation-container">
    <div class="white-box">
      <div class="header">
        <h1>Activate Your Account</h1>
      </div>
      <div class="content">
        <div class="info-box">
          <p class="subtitle">Activation Code</p>
          <p class="value">{{ activationCode }}</p>
        </div>
        <div class="info-box">
          <p class="subtitle">Email</p>
          <p class="value">{{ email }}</p>
        </div>
        <div class="info-box">
          <p class="subtitle">Response</p>
          <p class="value">{{ responseData.message }}</p>
        </div>
      </div>
      <div class="footer">
        <p>You will be redirected to the login page shortly.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.activation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.white-box {
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 500px;
  text-align: center;
}

.header, .footer {
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.content {
  padding: 16px;
}

.info-box {
  margin: 12px 0;
}

.subtitle {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;
}

.value {
  font-size: 18px;
  margin-bottom: 8px;
}
</style>

<script> 

import axios from 'axios';

export default {
  data() {
    return {
      activationCode: this.$route.query.activationCode,
      email: this.$route.query.email,
      responseData: ''
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      handler: function() {
        this.activationCode = this.$route.query.activationCode;
        this.email = this.$route.query.email;
        this.sendPostRequest();
      }
    }
  },
  mounted () {
    this.sendPostRequest();
  },
  methods: {
    async sendPostRequest () {
      try {
        const response = await axios.post('/auth/activate', {
          activationCode: this.activationCode,
          email: this.email
        });
        this.responseData = response.data;
        setTimeout(() => {
          this.$router.push("/login");
        }, 6000);
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user-activation/Activate.vue